/*
 * Aslan: pre-fills the Request a Quote form from the URL.
 *   ?product=...  fills the first contact field whose name contains "product"
 *   ?type=custom  selects the request-type option containing "custom"
 *   ?org=defense  selects the organization-type option containing "defense"
 * The form itself is Enterprise's contact-form section (templates/page.request-a-quote.json),
 * so fields are edited in the theme editor. Renaming the "Product or part number",
 * "Request type" or "Organization type" fields to drop those words would stop the pre-fill.
 */
(() => {
  const params = new URLSearchParams(window.location.search);
  const product = params.get('product');
  const type = params.get('type');
  const org = params.get('org');
  if (!product && !type && !org) return;

  const pick = (form, nameMatch, value) => {
    const select = [...form.querySelectorAll('select[name^="contact["]')].find((el) => nameMatch.test(el.name));
    const wanted = value.toLowerCase();
    const option = select && [...select.options].find((o) => o.value.toLowerCase().includes(wanted));
    if (option) select.value = option.value;
  };

  document.querySelectorAll('form[action*="/contact"]').forEach((form) => {
    if (product) {
      const input = [...form.querySelectorAll('input[name^="contact["]')].find((el) => /product/i.test(el.name));
      if (input && !input.value) input.value = product;
    }
    if (type) pick(form, /request/i, type);
    if (org) pick(form, /organization/i, org);
  });
})();
